import SUV from "./SUV";

export default SUV;